import type { RequestFn } from '../http';
import type {
  BinsResponse,
  NormalizedBin,
  NormalizedWarehouse,
  OnHandResponse,
  WarehousesResponse,
} from '../types';

export function createInventoryReadApi(request: RequestFn) {
  return {
    async getWarehouses(options?: { q?: string; page?: number; pageSize?: number }) {
      const params = new URLSearchParams();
      if (options?.q) params.set('q', options.q);
      if (options?.page) params.set('page', String(options.page));
      if (options?.pageSize) params.set('pageSize', String(options.pageSize));
      const query = params.toString() ? `?${params.toString()}` : '';
      return request<WarehousesResponse>(`/inventory/warehouses${query}`);
    },

    async getWarehouse(warehouseId: number) {
      return request<{ warehouse: NormalizedWarehouse }>(`/inventory/warehouses/${warehouseId}`);
    },

    async getWarehouseBins(
      warehouseId: number,
      options?: { q?: string; page?: number; pageSize?: number }
    ) {
      const params = new URLSearchParams();
      if (options?.q) params.set('q', options.q);
      if (options?.page) params.set('page', String(options.page));
      if (options?.pageSize) params.set('pageSize', String(options.pageSize));
      const query = params.toString() ? `?${params.toString()}` : '';
      return request<BinsResponse>(`/inventory/warehouses/${warehouseId}/bins${query}`);
    },

    async getBin(binId: number) {
      return request<{ bin: NormalizedBin }>(`/inventory/bins/${binId}`);
    },

    async getBinOnHand(binId: number, options?: { q?: string; page?: number; pageSize?: number }) {
      const params = new URLSearchParams();
      if (options?.q) params.set('q', options.q);
      if (options?.page) params.set('page', String(options.page));
      if (options?.pageSize) params.set('pageSize', String(options.pageSize));
      const query = params.toString() ? `?${params.toString()}` : '';
      return request<OnHandResponse>(`/inventory/bins/${binId}/onhand${query}`);
    },

    async clearInventoryCache() {
      return request<{ success: boolean; message: string }>('/inventory/cache/clear', {
        method: 'POST',
      });
    },

    async createWarehouse(body: {
      name: string;
      companyId?: number;
      locationId?: number;
    }) {
      return request<{ warehouse: NormalizedWarehouse }>('/inventory/warehouses', {
        method: 'POST',
        body: JSON.stringify(body),
      });
    },

    async createWarehouseBin(
      warehouseId: number,
      body: {
        name: string;
        locationId?: number;
        departmentId?: number;
        minQuantity?: number;
        maxQuantity?: number;
      }
    ) {
      return request<{ bin: NormalizedBin }>(
        `/inventory/warehouses/${warehouseId}/bins`,
        {
          method: 'POST',
          body: JSON.stringify(body),
        }
      );
    },
  };
}
